export default {
  name: 'CCarousel'
};